import { put, takeLeading } from 'redux-saga/effects';

import { apiErrorHandler } from 'utils';
import analyticsApi from 'api/analytics';

import * as Actions from './actions';
import * as ActionTypes from './actionTypes';

function* getPerformanceStatics({ payload }) {
  try {
    const data = yield analyticsApi.getPerformanceStatics(payload);

    yield put(Actions.getPerformanceStaticsSuccess(data.payload));
  } catch (error) {
    apiErrorHandler(error);

    yield put(Actions.getPerformanceStaticsFailure());
  }
}

function* getPerformanceOverviews({ payload }) {
  try {
    const data = yield analyticsApi.getPerformanceOverviews(payload);

    yield put(Actions.getPerformanceOverviewsSuccess(data.payload));
  } catch (error) {
    apiErrorHandler(error);

    yield put(Actions.getPerformanceOverviewsFailure());
  }
}

function* getPerformanceCharts({ payload }) {
  try {
    const data = yield analyticsApi.getPerformanceCharts(payload);

    yield put(Actions.getPerformanceChartsSuccess(data.payload));
  } catch (error) {
    apiErrorHandler(error);

    yield put(Actions.getPerformanceChartsFailure());
  }
}

function* getInsightOverview({ payload }) {
  try {
    const data = yield analyticsApi.getInsightOverview(payload);

    yield put(Actions.getInsightOverviewSuccess(data.payload));
  } catch (error) {
    apiErrorHandler(error);

    yield put(Actions.getInsightOverviewFailed());
  }
}

function* getRevenueDistributionOverview({ payload }) {
  try {
    const data = yield analyticsApi.getRevenueDistributionOverview(payload);

    yield put(Actions.getRevenueDistributionOverviewSuccess(data.payload.data));
  } catch (error) {
    apiErrorHandler(error);

    yield put(Actions.getRevenueDistributionOverviewFailed());
  }
}

function* getRevenueDistributionChart({ payload }) {
  try {
    const data = yield analyticsApi.getRevenueDistributionChart(payload);

    yield put(Actions.getRevenueDistributionChartSuccess(data.payload.data));
  } catch (error) {
    apiErrorHandler(error);

    yield put(Actions.getRevenueDistributionChartFailed());
  }
}

export default function* analytics() {
  yield takeLeading(ActionTypes.GET_PERFORMANCE_CHARTS, getPerformanceCharts);
  yield takeLeading(ActionTypes.GET_PERFORMANCE_STATICS, getPerformanceStatics);
  yield takeLeading(ActionTypes.GET_PERFORMANCE_OVERVIEWS, getPerformanceOverviews);

  yield takeLeading(ActionTypes.GET_INSIGHT_OVERVIEW, getInsightOverview);
  yield takeLeading(ActionTypes.GET_REVENUE_DISTRIBUTION_CHART, getRevenueDistributionChart);
  yield takeLeading(ActionTypes.GET_REVENUE_DISTRIBUTION_OVERVIEW, getRevenueDistributionOverview);
}
